import { useProject } from "../../actions/homeActions";
import { useNavigate } from "react-router-dom";

export default () => {
  const navigate = useNavigate();
  const baseURL = process.env.REACT_APP_BASE_URL;
  const { data: projectData, isLoading, isError, error } = useProject();
  
  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1, // Changed from 4
    slidesToScroll: 1,
    variableWidth: true,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    // Remove centerPadding - it was causing width issues
    responsive: [
      {
        breakpoint: 9999, // All screen sizes
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: true,
        }
      }
    ]
  };
  
  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">
          Error loading project : {error.message}
        </p>
      </div>
    );
  }

  const handleEvents = (id) => {
    navigate(`/project-details/${id}`);
  };
  
  return { isLoading, projectData, handleEvents, sliderSettings, baseURL };
};